<template>
    <v-card class="preview mx-auto" v-if="plant">

        <v-card-actions  @click="expand = !expand">
            <v-btn text>{{$t('key.briefing')}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn text>
                <v-icon>{{expand ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
            </v-btn>
        </v-card-actions>

        <v-expand-transition>
            <div v-show="expand">
                <v-row>
                    <v-col md="6" lg="5">
                        <ImageCarousel :refId="plantId"></ImageCarousel>
                    </v-col>
                    <v-col md="6">
                        <v-card-text>
                            <div v-html="compiledMarkdown"></div>
                        </v-card-text>
                    </v-col>
                </v-row>
            </div>
        </v-expand-transition>
    </v-card>
</template>

<script>
    import marked from 'marked'
    import ImageCarousel from '../../base/ImageCarousel'

    export default {
        name: 'PlantPreview',
        props: ['plantId'],
        components: {
            ImageCarousel
        },
        data: () => ({
            expand: false
        }),
        computed: {
            plant() {
                return this.$store.getters.plantList.find(plant => plant.uuid === this.plantId)
            },
            compiledMarkdown() {
                return marked(this.plant.briefing)
            }
        }
    }
</script>

<style lang="scss">
    div.preview {
        background-color: lightgrey;
    }
</style>
